module.exports = __webpack_public_path__ + "static/media/2.84f818b9.jpg";